import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Esto reemplaza a un psicólogo o psiquiatra?',
  a: 'No. Este material es psicoeducativo y está basado en técnicas validadas científicamente. Complementa cualquier tratamiento profesional y te da herramientas para el día a día. Si tenés síntomas severos, recomendamos acompañamiento profesional.'
}, {
  q: '¿Funciona si mi ansiedad es muy severa?',
  a: 'El material está diseñado para distintos niveles. Si tu ansiedad es severa o tenés varios ataques por semana, usá el pack junto a un profesional. Para ansiedad moderada, es una herramienta completa.'
}, {
  q: '¿Cómo recibo los PDFs?',
  a: 'Apenas se confirma el pago recibís un email automático con el link de descarga de todos los archivos. El acceso es inmediato y de por vida.'
}, {
  q: '¿Necesito conocimientos previos de psicología?',
  a: 'Cero. Todo está explicado en lenguaje cotidiano con ejemplos de vida real adaptados a LATAM. No necesitás saber nada previo.'
}, {
  q: '¿En qué dispositivos puedo leerlo?',
  a: 'En cualquiera: celular, tablet o computadora. Son archivos PDF compatibles con cualquier lector. También podés imprimirlos en tamaño A4.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía por inconvenientes. Escribinos al email de contacto y te devolvemos el 100% sin preguntas ni condiciones.'
}, {
  q: '¿Puedo compartirlo con mi pareja o familia?',
  a: "El pack es para uso personal. Incluye el Bonus 6 'Mini Kit para la Familia' pensado para que tu entorno sepa cómo ayudarte."
}];
export function FAQSection() {
  const {
    ref,
    isInView
  } = useInView();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 bg-primary" ref={ref} data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-3xl sm:text-4xl font-bold text-white mb-8 text-center" data-id="element-36">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-2" data-id="element-37">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`border-b border-card overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-card rounded-t-lg border-transparent' : ''}`} data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-39">
                <span className="text-white font-semibold pr-4" data-id="element-40">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-accent-gold shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
              </button>
              <AnimatePresence data-id="element-42">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="px-4 pb-4" data-id="element-43">
                    <p className="text-text-secondary leading-relaxed" data-id="element-44">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}